import React, { Component } from 'react';
import aidao from './../../../assets/images/Aidao.svg';
import PopUp from './popup.js';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';

export default class OTP extends Component {

  render() {

    const data = this.props.data;

    var otp = window.otp;
    if (otp === "True") {
      $(document).ready(function() {
        $('#google-authenticator').html(data.enabled);
        $('#google-authenticator').prop('disabled', true);
        $('#google-authenticator').removeClass('btn-default');
        $('#google-authenticator').addClass('btn-success');
      });
    }


    var getqrcode = function() {
      axios.defaults.xsrfCookieName = 'csrftoken';
      axios.defaults.xsrfHeaderName = 'X-CSRFToken';
      var request = axios.get('/api/addopt');
      request.then(function (response) {
        $("#insert-qr-image").html(response.data.image);
      });
      request.catch(function (error) {
        PopUp.prototype.show(data.failed + ":\n"+ error.response.data.message);
      });
    }

    var confirmqrcode = function() {
        axios.defaults.xsrfCookieName = 'csrftoken';
        axios.defaults.xsrfHeaderName = 'X-CSRFToken';
        console.log($("#confirm-token").val());
        var request = axios.post('/api/addopt', qs.stringify({
          "token": $("#confirm-token").val(),
        }));
        request.then(function (response) {
          PopUp.prototype.show(response.data.status);
          window.location.reload();
        });
        request.catch(function (error) {
          PopUp.prototype.show(data.failed + ":\n" + error.response.data.message);
        });
    }

    return (
      <div>

        <div class="row">
            <div class="col-md-12">
                <div class="card-box">
                    <div class="text-left m-t-20">
                        <h4 class="header-title m-t-0 m-b-30">{data.twoFaVerification}</h4>
                        <p>{data.noticeTwoFa}</p>
                        <div class="m-b-20">
                        </div>
                        <button id="google-authenticator" class="btn btn-default btn-lg waves-effect waves-light" data-toggle="modal" data-target="#otp-modal" onClick={getqrcode}>{data.verifyGoogle2FA}</button>
                    </div>

                </div>
            </div>
        </div>

        <div id="otp-modal" class="modal fade in" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="fixed-card-box">
              <div>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
              </div>

              <div class="otp-icon-center">
              <img src={aidao} alt="aidao" class="token64"></img>
              </div>

              <h3 class="m-t-10 m-b-20 text-center">{data.googleVerification}</h3>
              <h5 class="m-t-10 m-b-20 text-center">{data.firstStep}</h5>

              <p class="text-center m-b-20">{data.scanQRcode}</p>

              <div class="qr_code" id="insert-qr-image">{data.qrcode}</div>

              <div class="m-t-20"></div>

              <h5 class="m-t-10 m-b-20 text-center">{data.secondStep}</h5>
              <p class="text-center m-b-20"></p>

              <div class="half-center">
                <input class="form-control center-input" id="confirm-token" name="2fa type=text"></input>
                <div class="m-b-20"></div>
                <button class="btn btn-default btn-block waves-effect waves-light text-center" onClick={confirmqrcode}>{data.confirm}</button>
                <div class="m-b-20"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/otp.js